import {useContext, useEffect, useState} from 'react';
import {RenderConditionContext} from '@/app/contexts/RenderConditionContext';

/**
 * The hook indicates whether to render the highlight of the current hour in the hourly forecast table.
 * This is necessary to avoid rendering of the highlight of the current hour at the stage of server rendering
 * as well as at the stage of hydration on the client side.
 */
export function useShouldHighlightCurrentHour(hasCurrentHour: boolean) {
	const {isSSR, isHydration} = useContext(RenderConditionContext).current;
	const isSsrOrHydrationMode = isSSR || isHydration;
	const [highlightCurrentHour, setHighlightCurrentHour] = useState(!isSsrOrHydrationMode);

	useEffect(() => {
		if (!highlightCurrentHour && hasCurrentHour) {
			setHighlightCurrentHour(true);
		}
	}, [hasCurrentHour]);

	return highlightCurrentHour;
}

useShouldHighlightCurrentHour.displayName = 'useShouldHighlightCurrentHour';
